import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconMoreHorizSvg } from "./IconMoreHorizSvg.mjs";
const IconMoreHoriz = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconMoreHorizSvg, ...iconProps });
};
export {
  IconMoreHoriz
};
